import { render, staticRenderFns } from "./OutfitSelector.vue?vue&type=template&id=26252bb0&scoped=true&"
import script from "./OutfitSelector.vue?vue&type=script&lang=js&"
export * from "./OutfitSelector.vue?vue&type=script&lang=js&"
import style0 from "./OutfitSelector.vue?vue&type=style&index=0&id=26252bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26252bb0",
  null
  
)

export default component.exports